<template>
  <div class="w100 card-shadow bg-w">
    <div class="w100 flex-box al-c bor-b pt10 pb10 pl10" style="color: #02a5bd">
      <img class="mr10" :src="`${baseUrl}images/icon-home-app.png`">
      <span class="font-18 mr10" style="color: #02a5bd">工具</span>
      <span class="font-14 grey">Tool</span>
    </div>
    <el-row class="w100" v-loading="loading">
      <el-col :span="12" v-for="(item, index) in list" :key="index">
        <a class="block w100 pt10 cu-p tx-c app-item" target="_blank" :href="item.toolUrl">
          <img class="app-img" :src="item.toolIcon ? item.toolIcon : `${baseUrl}images/icon-app.png`" style="width: 60px; height: 60px; border-radius: 50%;">
          <!-- <el-image class="tool-img" :src="item.toolIcon" lazy style="width: 40px; height: 40px; border-radius: 50%;">
            <img :src="`${baseUrl}images/icon-app.png`" width="40" height="40" slot="error">
          </el-image> -->
          <p class="mt10 pl20 pr20 font-14 ellipsis">{{ item.toolName }}</p>
        </a>
      </el-col>
      <el-col class="pt20 pb20 tx-c grey font-14" :span="24" v-if="list.length == 0">暂无可用工具</el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "HomeTool",
  components: {},
  props: ["tourist-active"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      list: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.fetchList();
  },
  destroyed() {},
  methods: {
    fetchList() {
      this.loading = true;
      this.$http
        .post(
          "/tool/toolPermitList",
          this.$qs.stringify({
            pageNum: 1,
            pageSize: 100
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    touristActive() {
      this.fetchList();
    }
  },
  filters: {}
};
</script>

<style scoped>
.app-item {
  height: 100px;
}

.app-item:hover {
  background: #edf5fe;
}
.tool-img {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>
